import { TaskDefinition, TaskStatus } from '@/feature/execution-board'

import styles from './TaskProgressCell.module.css'

export const TaskProgressCell = ({
  task,
  tripProgress,
}: {
  task: TaskDefinition
  tripProgress?: number
}) => {
  if (task.status !== TaskStatus.IN_PROGRESS) {
    return (
      <div className={styles.progressCell}>
        <span className={styles.progressText}>-</span>
      </div>
    )
  }

  if (tripProgress == null) {
    return (
      <div className={styles.progressCell}>
        <span className={styles.progressText}>-</span>
      </div>
    )
  }

  const displayProgress = Math.round(tripProgress)

  return (
    <div className={styles.progressCell} title={`${displayProgress}% complete`}>
      <span className={styles.progressText}>{displayProgress}%</span>
      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${displayProgress}%` }} />
      </div>
    </div>
  )
}
